export function init() {

	// Scroll buttons in page header ------------------------------------------------------------------ //

	if (document.querySelector('.btn.-scrollto')) {
		const scrollButtons = document.querySelectorAll('.btn.-scrollto');
		scrollButtons.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				const scrollTo = document.querySelector('section:nth-of-type(' + e.target.dataset.scrollto + ')');
				scrollTo.scrollIntoView();
			});
		});
	}

	// Masonry-style timeline layout ------------------------------------------------------------------ //

	if (document.querySelector('.module-timeline')) {

		let col1height = 0;
		let col2height = 100; // accomodate initial offset of 2nd col

		const allTimelineItems = document.querySelectorAll('.module-timeline .timeline-list .timeline-item');

		allTimelineItems.forEach((el) => {

			const dupeElement = el.cloneNode(true);

			let colToAdd = document.querySelector('.timeline-full .-col-1');

			if (col2height < col1height) {
				colToAdd = document.querySelector('.timeline-full .-col-2');
			}

			colToAdd.appendChild(dupeElement);

			if (col2height < col1height) {
				col2height += dupeElement.offsetHeight;
			} else {
				col1height += dupeElement.offsetHeight;
			}

		});

	}
	
}